import { Controller, FormProvider } from 'react-hook-form';
import { StanButton, StanInput } from '@/components';
import { useAffiliateLoginForm } from '../hooks/useAffiliateLoginForm';
import IconPerson from '@/assets/icons/ic-profile.svg';
import IconLock from '@/assets/icons/ic-lock.svg';

interface AffiliateLoginFormProps {
    /** JWT token for API authorization */
    token: string;
    /** Callback when login and transfer succeeds */
    onSuccess: () => void;
}

export function AffiliateLoginForm({ token, onSuccess }: AffiliateLoginFormProps) {
    const { form, onSubmit, isSubmitting, loginError } = useAffiliateLoginForm({
        token,
        onSuccess,
    });

    const {
        control,
        formState: { errors },
    } = form;

    return (
        <FormProvider {...form}>
            <form onSubmit={onSubmit} className='space-y-2.5'>
                {/* Email or Username Input */}
                <Controller
                    name='emailOrUsername'
                    control={control}
                    render={({ field }) => (
                        <StanInput
                            id='emailOrUsername'
                            name={field.name}
                            type='text'
                            placeholder='Stan Email or Username'
                            value={field.value}
                            onChange={field.onChange}
                            onBlur={field.onBlur}
                            disabled={isSubmitting}
                            error={!!errors.emailOrUsername}
                            hintText={errors.emailOrUsername?.message}
                            startIcon={IconPerson}
                        />
                    )}
                />

                {/* Password Input */}
                <Controller
                    name='password'
                    control={control}
                    render={({ field }) => (
                        <StanInput
                            id='password'
                            name={field.name}
                            type='password'
                            placeholder='Stan Password'
                            value={field.value}
                            onChange={field.onChange}
                            onBlur={field.onBlur}
                            disabled={isSubmitting}
                            error={!!errors.password || !!loginError}
                            hintText={errors.password?.message || loginError}
                            startIcon={IconLock}
                        />
                    )}
                />

                {/* Submit Button */}
                <div className='pt-6'>
                    <StanButton
                        type='submit'
                        name='affiliate-login-submit'
                        color='primary'
                        className='w-full'
                        disabled={isSubmitting}
                        loading={isSubmitting}
                    >
                        Start Reselling
                    </StanButton>
                </div>
            </form>
        </FormProvider>
    );
}
